import { render, staticRenderFns } from "./Gen.vue?vue&type=template&id=e97bb5da&scoped=true"
import script from "./Gen.vue?vue&type=script&lang=js"
export * from "./Gen.vue?vue&type=script&lang=js"
import style1 from "./Gen.vue?vue&type=style&index=1&id=e97bb5da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97bb5da",
  null
  
)

export default component.exports